module.exports = __webpack_public_path__ + "static/media/logout.b2e84d98.svg";